import { useState } from 'react';

function JobSubmitForm({ onSubmit, onClose }) {
  const [jobType, setJobType] = useState('echo');
  const [inputs, setInputs] = useState({ message: '' });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({
      job_type: { name: jobType },
      inputs: inputs,
    });
  };

  const handleInputChange = (key, value) => {
    setInputs((prev) => ({ ...prev, [key]: value }));
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" data-testid="job-submit-modal">
      <div className="bg-white rounded-lg p-6 w-full max-w-md">
        <h3 className="text-xl font-bold mb-4 text-gray-900">Submit Job</h3>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Job Type
            </label>
            <select
              value={jobType}
              onChange={(e) => setJobType(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
              data-testid="job-submit-type-select"
            >
              <option value="echo">Echo</option>
              <option value="sleep">Sleep</option>
              <option value="fibonacci">Fibonacci</option>
            </select>
          </div>

          {/* Echo job inputs */}
          {jobType === 'echo' && (
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Message
              </label>
              <input
                type="text"
                value={inputs.message || ''}
                onChange={(e) => handleInputChange('message', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
                placeholder="Hello, World!"
                data-testid="job-submit-input-message"
              />
            </div>
          )}

          {/* Sleep job inputs */}
          {jobType === 'sleep' && (
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Duration (seconds)
              </label>
              <input
                type="number"
                value={inputs.duration_seconds || ''}
                onChange={(e) =>
                  handleInputChange('duration_seconds', parseInt(e.target.value) || 0)
                }
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
                placeholder="5"
                min="1"
                max="60"
                data-testid="job-submit-input-duration"
              />
            </div>
          )}

          {/* Fibonacci job inputs */}
          {jobType === 'fibonacci' && (
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Number (n)
              </label>
              <input
                type="number"
                value={inputs.n || ''}
                onChange={(e) => handleInputChange('n', parseInt(e.target.value) || 0)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
                placeholder="10"
                min="1"
                max="40"
                data-testid="job-submit-input-n"
              />
            </div>
          )}

          <div className="flex gap-3 justify-end">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg transition"
              data-testid="job-submit-cancel-button"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition"
              data-testid="job-submit-submit-button"
            >
              Submit Job
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default JobSubmitForm;
